import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { StoreData } from '../reducers/typings'
import { ITargetPest } from './typings'
import { getTargetPests } from './api'

const targetPestAdapter = createEntityAdapter<ITargetPest>({
  sortComparer: (a, b) => a.name.localeCompare(b.name),
})

export const initialState = targetPestAdapter.getInitialState()

const targetPests = createSlice({
  name: 'targetPests',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTargetPests.pending, (state) => {
      targetPestAdapter.removeAll(state)
    })
    builder.addCase(getTargetPests.fulfilled, (state, { payload }) =>
      targetPestAdapter.setAll(state, payload),
    )
  },
})

export default targetPests.reducer

export const { selectAll: selectAllTargetPests } =
  targetPestAdapter.getSelectors<StoreData>((state) => state.targetPests)

export const activeTargetPests = (targetPests: ITargetPest[]): ITargetPest[] =>
  targetPests.filter((p) => p.active && p.name != '')
